<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>Transfer Booking - {{ this.bookingData?.transferId }}</h2>
</div>


<nz-tabset>
  <nz-tab nzTitle="Booking Details">

    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <section id="bookingDetails" class="mt-5">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Booking Details</h5>
              <div>
                <button nz-button nzType="primary" [disabled]="editBtnDisableCheck(bookingData)" (click)="editNavigate(bookingData._id)" style="max-width: 120px">Edit
                  Details
                </button>
              </div>

            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Booking Received Date</p>
                    <p class="subject-data">{{
                        bookingData?.bookingDetails?.bookingReceivedDate ?
                          (bookingData?.bookingDetails?.bookingReceivedDate | date:'yyyy-MM-dd') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Booking Type</p>
                    <p class="subject-data">{{
                        bookingData?.bookingDetails ? (bookingData?.bookingDetails?.bookingType)
                          : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Agent</p>
                    <p class="subject-data">{{
                        bookingData?.bookingDetails?.agent ?
                          (bookingData?.bookingDetails?.agent?.name) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Booking Reference</p>
                    <p class="subject-data">{{
                        bookingData?.bookingDetails?.bookingReference ?
                          (bookingData?.bookingDetails?.bookingReference) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Booking Category</p>
                    <p *ngIf="(bookingData?.tourDetails?.departureCheck !== true)" class="subject-data">{{
                        bookingData?.bookingDetails?.bookingCategory ? (bookingData?.bookingDetails?.bookingCategory) :
                          '-'
                      }}</p>
                    <p
                      *ngIf="(bookingData?.bookingDetails?.bookingCategory === 'Arrival') && (bookingData?.tourDetails?.departureCheck === true)"
                      class="subject-data">{{ 'Arrival and Departure' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nz-card>
      </section>

      <section id="customerDetails" class="mt-5">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Customer Details</h5>
              <button class="" nz-button nzType="primary" (click)="showCustomerModal()">View Customer Profile
              </button>
            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Full Name</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.customer?.renterDetails?.fullName ?
                          ( bookingData?.tourDetails?.customer?.renterDetails?.fullName) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Country</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.customer?.renterDetails?.homeCountry ?
                          (bookingData?.tourDetails?.customer?.renterDetails?.homeCountry) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Contact Number</p>
                    <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{
                        bookingData?.tourDetails?.customer?.renterDetails?.contactNo ?
                          (bookingData?.tourDetails?.customer?.renterDetails?.contactNo) : '-'
                      }}">{{
                        bookingData?.tourDetails?.customer?.renterDetails?.contactNo ?
                          (bookingData?.tourDetails?.customer?.renterDetails?.contactNo) : '-'
                      }}</a></p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Date of Birth</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.customer?.renterDetails?.dob ?
                          (bookingData?.tourDetails?.customer?.renterDetails?.dob | date:'yyyy-MM-dd') : '-'
                      }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Home Address</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.customer?.renterDetails?.homeAddress ?
                          (bookingData?.tourDetails?.customer?.renterDetails?.homeAddress) : '-'
                      }}</p>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>


  </nz-tab>

  <!-- Arrival Information -->
  <nz-tab [nzTitle]="loading ? '' : titleTemplate"
          *ngIf="this.bookingData?.bookingDetails?.bookingCategory === 'Arrival'">
    <ng-template #titleTemplate>
      Arrival Information
      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.arrivalDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'COMPLETED', false)"
        [nzColor]="'#3ab200'"
        class="rounded-full">Completed
      </nz-tag>
      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.arrivalDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'CANCELLED', false)"
        class="rounded-full" [nzColor]="'#F3454C'">Cancelled
      </nz-tag>
      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.arrivalDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'RESERVATION', false)"
        [nzColor]="'#FF8C00'" class="rounded-full">Reservation
      </nz-tag>
      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.arrivalDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'ON_TRANSFER', false)"
        [nzColor]="'#4655f5'" class="rounded-full">On Transfer
      </nz-tag>
      <a *appHasAnyPrivilege="'TRANSFER_BOOKING_CHANGE_STATUS'" nz-dropdown [nzDropdownMenu]="menu"
         nzPlacement="bottomCenter">
          <span>
            <nz-tag *ngIf="bookingData?.arrivalDetails?.status === 'COMPLETED'" [nzColor]="'#3ab200'"
                    class="rounded-full">Completed
            </nz-tag>
            <nz-tag *ngIf="bookingData?.arrivalDetails?.status === 'CANCELLED'" class="rounded-full"
                    [nzColor]="'#F3454C'">Cancelled
            </nz-tag>
            <nz-tag *ngIf="bookingData?.arrivalDetails?.status === 'RESERVATION'" [nzColor]="'#FF8C00'"
                    class="rounded-full">Reservation
            </nz-tag>
            <nz-tag *ngIf="bookingData?.arrivalDetails?.status === 'ON_TRANSFER'" [nzColor]="'#4655f5'"
                    class="rounded-full">On Transfer
            </nz-tag>
          </span>
      </a>

      <nz-dropdown-menu #menu="nzDropdownMenu">
          <span *ngIf="bookingData?.arrivalDetails.status !== 'COMPLETED'">
          <ul nz-menu>

                <li nz-menu-item nz-popconfirm
                    *ngIf="(bookingData?.arrivalDetails.status === 'CANCELLED')"
                    nzPopconfirmTitle="Are you sure you want change the status to Reservation?" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('RESERVATION', 'single')">Reservation
                </li>
                <li nz-menu-item nz-popconfirm
                    *ngIf="( bookingData?.arrivalDetails.status === 'RESERVATION')"
                    nzPopconfirmTitle="Are you sure you want change the status to On Transfer" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('ON_TRANSFER', 'single')">OnTransfer
                </li>
                <li nz-menu-item nz-popconfirm
                    *ngIf="(bookingData?.arrivalDetails.status === 'ON_TRANSFER')"
                    nzPopconfirmTitle="Are you sure you want change the status to Completed?" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('COMPLETED', 'single')">Completed
                </li>
                <li nz-menu-item nz-popconfirm
                    *ngIf="(bookingData?.arrivalDetails.status === 'RESERVATION' || bookingData?.arrivalDetails.status === 'ON_TRANSFER')"
                    nzPopconfirmTitle="Are you sure you want change the status to Cancelled?" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('CANCELLED','single');setFlag('Arrival')">Cancelled
                </li>
              </ul>

          </span>
      </nz-dropdown-menu>
    </ng-template>

    <div [ngClass]="!loading ? 'block' : 'hidden'">
      <nz-card>
        <div class="flex flex-row flex-wrap items-center justify-end gap-2">
          <button nz-button nzType="primary" (click)="this.openEndDataModal('Arrival')"
                  [disabled]="bookingData?.arrivalDetails.status !== 'ON_TRANSFER'">Add Another Allocation
          </button>
          <button nz-button nzType="primary" *ngIf="bookingData.arrivalDetails.driverCategory === 'OUTSOURCE_DRIVER'"
                  (click)="showReportGenerate();generatePdf('arrival')">Invoice - Outsourced Vehicles
          </button>
        </div>
      </nz-card>

      <section id="arrivalDetails" class="mt-5">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Arrival Details</h5>
              <div>

              </div>
            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Arrival Flight Number</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.arrivalFlightNumber ?
                          (bookingData?.tourDetails?.arrivalFlightNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Arrival Flight Time</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.arrivalFlightTime ?
                          (bookingData?.tourDetails?.arrivalFlightTime | date:'hh:mm a') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Flight Date</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.arrivalFlightDate ?
                          (bookingData?.tourDetails?.arrivalFlightDate | date:'yyyy-MM-dd') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Pick Up Time</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.pickUpTime ?
                          (bookingData?.tourDetails?.pickUpTime | date:'hh:mm a') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">PickUp Location</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.pickUpLocation ?
                          (bookingData?.tourDetails?.pickUpLocation) : '-'
                      }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Drop Off Location</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.dropOffLocation ?
                          (bookingData?.tourDetails?.dropOffLocation) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Drop Off City</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.dropOffCity ?
                          (bookingData?.tourDetails?.dropOffCity) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Distance to destination</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.distanceToDestination ?
                          (bookingData?.tourDetails?.distanceToDestination + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Date</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.arrivalEndDate ?
                          (bookingData?.tourDetails?.arrivalEndDate | date:'yyyy-MM-dd') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Time</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.arrivalEndTime ?
                          (bookingData?.tourDetails?.arrivalEndTime | date:'hh:mm a') : '-'
                      }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Number of Luggage</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.noOfLuggages ?
                          (bookingData?.tourDetails?.noOfLuggages) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Number of Passengers</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.noOfPassengers ?
                          (bookingData?.tourDetails?.noOfPassengers) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">N0. of Adults</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.noOfAdults ?
                          (bookingData?.tourDetails?.noOfAdults) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">No. of Children</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.noOfChildren ?
                          (bookingData?.tourDetails?.noOfChildren) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">No. of Infants</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.noOfInfants ?
                          (bookingData?.tourDetails?.noOfInfants) : '-'
                      }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>

      <section id="VehicleDetails" class="mt-5" *ngIf="bookingData.arrivalDetails?.driverCategory === 'SR_DRIVER' ">

        <nz-card>
          <div>

            <div class="flex justify-between gap-2 flex-col xl:flex-row">
              <h5 class="text-primary">Vehicle Details</h5>
              <div class="flex flex-wrap lg:flex-nowrap lg:flex-row gap-2 items-center xl:justify-end ">
                <button nz-button (click)="navigate('INSPECTION','arrival')">Add Inspection Record</button>
                <button nz-button (click)="navigate('ACCIDENT','arrival')">Add Accident Record</button>
                <button nz-button *ngIf="checkCanShowGenerateInventoryReport()"
                        (click)="showGenerateInventoryReportPopup(bookingData?.arrivalDetails?.allocatedVehicle?._id)">
                  Generate Inventory Report
                </button>
              </div>
            </div>


            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div>
                <div class="sub-section" style="height: 100%">
                  <img *ngIf="bookingData?.arrivalDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       height="nzAutosize" width="100%"
                       [src]="bookingData?.arrivalDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       alt="image">
                  <img *ngIf="!bookingData?.arrivalDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       height="nzAutosize" width="100%" src="assets/img/image-placeholder.png" alt="image">
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Vehicle Brand</p>
                    <p class="subject-data">{{
                        bookingData?.arrivalDetails?.allocatedVehicle?.vehicleDetails?.vehicleBrand ?
                          (bookingData.arrivalDetails.allocatedVehicle.vehicleDetails.vehicleBrand) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Model</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails?.allocatedVehicle?.vehicleDetails?.vehicleModel ?
                          (bookingData.arrivalDetails.allocatedVehicle.vehicleDetails.vehicleModel) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Fuel Type</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails?.allocatedVehicle?.vehicleDetails?.fuelType ?
                          (bookingData.arrivalDetails.allocatedVehicle.vehicleDetails.fuelType) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Transmission</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails?.allocatedVehicle?.vehicleDetails?.transmission ?
                          (bookingData.arrivalDetails.allocatedVehicle.vehicleDetails.transmission) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Registration Number</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber ?
                          (bookingData.arrivalDetails.allocatedVehicle.vehicleDetails.registrationNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">No. of Seats</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails?.allocatedVehicle?.vehicleDetails?.seatsNumber
                          ? (bookingData.arrivalDetails.allocatedVehicle.vehicleDetails.seatsNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Color</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails?.allocatedVehicle?.vehicleDetails?.color ?
                          (bookingData.arrivalDetails.allocatedVehicle.vehicleDetails.color) : '-'
                      }}</p>
                  </div>

                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Start Mileage</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails.startMileage ?
                          (bookingData.arrivalDetails.startMileage + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Start Fuel</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails.startFuel ?
                          (bookingData.arrivalDetails.startFuel + ' %') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Mileage</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails.endMileage ?
                          (bookingData.arrivalDetails.endMileage + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Fuel</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails.endFuel ?
                          (bookingData.arrivalDetails.endFuel + ' %') : '-'
                      }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>

      <section id="driverDetails" class="mt-5">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Driver Details</h5>

            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Driver Category</p>
                    <p *ngIf="bookingData.arrivalDetails?.allocateDriver?.driverSegment === 'SR_DRIVER'"
                       class="subject-data">SR Driver
                    </p>
                    <p *ngIf="bookingData.arrivalDetails?.allocateDriver?.driverSegment !== 'SR_DRIVER'"
                       class="subject-data">
                      Outsourced Driver</p>
                  </div>
                  <div class="item-row"
                       *ngIf="bookingData.arrivalDetails?.allocateDriver?.driverSegment !== 'SR_DRIVER'">
                    <p class="subject-name">Supplier</p>
                    <p style="cursor: pointer"
                       (click)="showSupplierModal(bookingData.arrivalDetails.allocateDriver.supplier)"
                       class="subject-data">{{
                        bookingData.arrivalDetails?.allocateDriver ?
                          bookingData.arrivalDetails?.allocateDriver?.supplier?.supplierDetails?.name : '-'
                      }}</p>
                  </div>
                  <div class="item-row"
                       *ngIf="bookingData.arrivalDetails?.allocateDriver?.driverSegment !== 'SR_DRIVER'">
                    <p class="subject-name">Outsourced Rate</p>
                    <p class="subject-data">{{
                        bookingData.arrivalDetails?.outsourcedRate ?
                          (bookingData.arrivalDetails?.outsourcedRate + ' ' + bookingData.arrivalDetails?.outsourcedRateCurrencyDetails?.currencyCode) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Can Drive</p>
                    <div *ngFor="let item of bookingData.arrivalDetails.allocateDriver?.canDrive">
                      <p class="subject-data">{{ item.label ? (item.label + ',') : '-' }}</p>
                    </div>
                  </div>

                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Driver Name</p>
                    <p (click)="showDriverModal(bookingData?.arrivalDetails?.allocateDriver)" style="cursor: pointer"
                       class="subject-data">{{
                        bookingData?.arrivalDetails?.allocateDriver?.fullName ?
                          (bookingData?.arrivalDetails?.allocateDriver?.fullName) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">NIC</p>
                    <p class="subject-data">{{
                        bookingData?.arrivalDetails?.allocateDriver?.nicNo ?
                          (bookingData?.arrivalDetails?.allocateDriver?.nicNo) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Mobile Number</p>
                    <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="tel:{{
                        bookingData?.arrivalDetails?.allocateDriver?.mobileNumber ?
                          (bookingData?.arrivalDetails?.allocateDriver?.mobileNumber) : '-'
                      }}">{{
                        bookingData?.arrivalDetails?.allocateDriver?.mobileNumber ?
                          (bookingData?.arrivalDetails?.allocateDriver?.mobileNumber) : '-'
                      }}</a></p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name clickable-mail-phone_no">Email</p>
                    <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no" href="mailto:{{
                        bookingData?.arrivalDetails?.allocateDriver?.email ?
                          (bookingData?.arrivalDetails?.allocateDriver?.email) : '-'
                      }}">{{
                        bookingData?.arrivalDetails?.allocateDriver?.email ?
                          (bookingData?.arrivalDetails?.allocateDriver?.email) : '-'
                      }}</a></p>
                  </div>


                </div>
              </div>

              <div *ngIf="this.bookingData.arrivalDetails?.driverCategory === 'OUTSOURCE_DRIVER'">
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Vehicle Model</p>
                    <p class="subject-data">{{ arrivalVeh.model }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Vehicle Registration Number</p>
                    <p class="subject-data">{{ arrivalVeh.reg }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>


      <div *ngFor="let item of this.bookingData?.arrivalDetails?.allocationList?.slice().reverse(); let i = index">
        <section id="VehicleAllocationDetails" class="mt-5"
                 *ngIf="item.vehicle">

          <nz-card>
            <div>
              <div class="flex justify-between gap-2 flex-col lg:flex-row">
                <h5 class="text-primary">Vehicle Allocation (Previous - No: {{ i + 1 }} )</h5>
                <div class="flex flex-wrap md:flex-nowrap md:flex-row gap-2 items-center lg:justify-end ">
                  <!--                  <button nz-button (click)="navigate('INSPECTION')">Add Inspection Record</button>-->
                  <!--                  <button nz-button (click)="navigate('ACCIDENT')">Add Accident Record</button>-->
                </div>
              </div>

              <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
                <div>
                  <div class="sub-section" style="height: 100%">
                    <img *ngIf="item.vehicle?.generalInformation?.vehicleImg[0]" height="nzAutosize" width="100%"
                         [src]="item.vehicle?.generalInformation?.vehicleImg[0]" alt="image">
                    <img *ngIf="!item.vehicle?.generalInformation?.vehicleImg[0]" height="nzAutosize" width="100%"
                         src="assets/img/image-placeholder.png" alt="image">
                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Vehicle Brand</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.vehicleBrand ?
                            (item.vehicle?.vehicleDetails.vehicleBrand) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Model</p>
                      <p class="subject-data">{{
                          bookingData.arrivalDetails?.vehicleDetails?.vehicleModel ?
                            (item.vehicle?.vehicleDetails.vehicleModel) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Fuel Type</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.fuelType ?
                            (item.vehicle?.vehicleDetails.fuelType) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Transmission</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.transmission ?
                            (item.vehicle?.vehicleDetails.transmission) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Registration Number</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.registrationNumber ?
                            (item.vehicle?.vehicleDetails.registrationNumber) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">No. of Seats</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.seatsNumber ?
                            (item.vehicle?.vehicleDetails.seatsNumber) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Color</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.color ?
                            (item.vehicle?.vehicleDetails.color) : '-'
                        }}</p>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Start Mileage</p>
                      <p class="subject-data">{{ item.startMileage ? (item.startMileage + ' KM') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Start Fuel</p>
                      <p class="subject-data">{{ item.startFuel ? (item.startFuel + ' %') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">End Mileage</p>
                      <p class="subject-data">{{ item.endMileage ? (item.endMileage + ' KM') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">End Fuel</p>
                      <p class="subject-data">{{ item.endFuel ? (item.endFuel + ' %') : '-' }}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </nz-card>
        </section>


        <section id="driverAllocationDetails" class="mt-5">

          <nz-card>
            <div>
              <div class="flex justify-between gap-2 flex-col md:flex-row">
                <h5 class="text-primary">Driver Details (Previous - No: {{ i + 1 }} )</h5>

              </div>
              <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Driver Category</p>
                      <p *ngIf="item.driver?.driverSegment === 'SR_DRIVER'" class="subject-data">SR Driver</p>
                      <p *ngIf="item.driver?.driverSegment !== 'SR_DRIVER'" class="subject-data">Outsourced Driver</p>
                    </div>
                    <div class="item-row" *ngIf="item.supplier !== ''">
                      <p class="subject-name">Supplier</p>
                      <p style="cursor: pointer" (click)="showSupplierModal(item.driver?.supplier)"
                         class="subject-data">{{ item.supplier ? item.supplier : '-' }}</p>
                    </div>
                    <div class="item-row" *ngIf="item.driver?.driverCategory === 'OUTSOURCE_DRIVER'">
                      <p class="subject-name">Outsourced Rate</p>
                      <p class="subject-data">{{ item.outRate ? item.outRate : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Can Drive</p>
                      <div *ngFor="let item of item.driver?.canDrive">
                        <p class="subject-data">{{ item.label ? (item.label + ',') : '-' }}</p>
                      </div>
                    </div>

                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Driver Name</p>
                      <p (click)="showDriverModal(item.driver)" style="cursor: pointer" class="subject-data">{{
                          item.driver?.fullName ? (item.driver?.fullName) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">NIC</p>
                      <p class="subject-data">{{ item.driver?.nicNo ? (item.driver?.nicNo) : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Mobile Number</p>
                      <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                         href="{{ item.driver?.mobileNumber ? (item.driver?.mobileNumber) : '-' }}">{{ item.driver?.mobileNumber ? (item.driver?.mobileNumber) : '-' }}</a>
                      </p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Email</p>
                      <p class="subject-data clickable-mail-phone_no"><a class="clickable-mail-phone_no"
                                                                         href="{{ item.driver?.email ? (item.driver?.email) : '-' }}">{{ item.driver?.email ? (item.driver?.email) : '-' }}</a>
                      </p>
                    </div>


                  </div>
                </div>

                <div *ngIf="!item.vehicle">
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Vehicle Model</p>
                      <p class="subject-data">{{ item.driverVehModel }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Vehicle Registration Number</p>
                      <p class="subject-data">{{ item.driverVehReg }}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </nz-card>
        </section>
      </div>
    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>

  </nz-tab>

  <!-- Departure Information -->
  <nz-tab [nzTitle]="loading ? '' : titleTemplate"
          *ngIf="(this.bookingData?.bookingDetails?.bookingCategory === 'Arrival' && this.bookingData?.tourDetails?.departureCheck === true) || (this.bookingData?.bookingDetails?.bookingCategory === 'Departure')">


    <ng-template #titleTemplate>
      Departure Information

      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.departureDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'COMPLETED', false)"
        [nzColor]="'#3ab200'" class="rounded-full">Completed
      </nz-tag>
      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.departureDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'CANCELLED', false)"
        class="rounded-full" [nzColor]="'#F3454C'">Cancelled
      </nz-tag>
      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.departureDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'RESERVATION', false)"
        [nzColor]="'#FF8C00'" class="rounded-full">Reservation
      </nz-tag>
      <nz-tag
        *ngIf="havePermissionWithStatus(bookingData?.departureDetails?.status, 'TRANSFER_BOOKING_CHANGE_STATUS', 'ON_TRANSFER', false)"
        [nzColor]="'#4655f5'" class="rounded-full">On Transfer
      </nz-tag>
      <a *appHasAnyPrivilege="'TRANSFER_BOOKING_CHANGE_STATUS'" nz-dropdown [nzDropdownMenu]="menu"
         nzPlacement="bottomCenter">
          <span>
            <nz-tag *ngIf="bookingData?.departureDetails?.status === 'COMPLETED'" [nzColor]="'#3ab200'"
                    class="rounded-full">Completed
            </nz-tag>
            <nz-tag *ngIf="bookingData?.departureDetails?.status === 'CANCELLED'" class="rounded-full"
                    [nzColor]="'#F3454C'">Cancelled
            </nz-tag>
            <nz-tag *ngIf="bookingData?.departureDetails?.status === 'RESERVATION'" [nzColor]="'#FF8C00'"
                    class="rounded-full">Reservation
            </nz-tag>
            <nz-tag *ngIf="bookingData?.departureDetails?.status === 'ON_TRANSFER'" [nzColor]="'#4655f5'"
                    class="rounded-full">On Transfer
            </nz-tag>
          </span>
      </a>

      <nz-dropdown-menu #menu="nzDropdownMenu">
           <span *ngIf="bookingData?.departureDetails.status !== 'COMPLETED'">

              <ul nz-menu>
                <li nz-menu-item nz-popconfirm
                    *ngIf="bookingData?.departureDetails?.status === 'CANCELLED'"
                    nzPopconfirmTitle="Are you sure you want change the status to Reservation?" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('RESERVATION', 'both')">Reservation
                </li>
                <li nz-menu-item nz-popconfirm
                    *ngIf="bookingData?.departureDetails?.status === 'RESERVATION'"
                    nzPopconfirmTitle="Are you sure you want change the status to On Transfer" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('ON_TRANSFER', 'both')">OnTransfer
                </li>
                <li nz-menu-item nz-popconfirm
                    *ngIf="bookingData?.departureDetails?.status === 'ON_TRANSFER'"
                    nzPopconfirmTitle="Are you sure you want change the status to Completed?" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('COMPLETED', 'both')">Completed
                </li>
                <li nz-menu-item nz-popconfirm
                    *ngIf="bookingData?.departureDetails?.status === 'RESERVATION' ||  bookingData?.departureDetails.status === 'ON_TRANSFER'"
                    nzPopconfirmTitle="Are you sure you want change the status to Cancelled?" [nzOkText]="'Yes'"
                    [nzCancelText]="'No'" (nzOnCancel)="handleCancelSelectStatus()"
                    (nzOnConfirm)="handleOkSelectStatus('CANCELLED','both');setFlag('Departure')">Cancelled
                </li>
              </ul>

           </span>
      </nz-dropdown-menu>
    </ng-template>

    <div [class]="!loading ? 'block' : 'hidden'">
      <nz-card>
        <div class="flex flex-row flex-wrap items-center justify-end gap-2">
          <button nz-button nzType="primary" [disabled]="bookingData?.departureDetails.status !== 'ON_TRANSFER'"
                  (click)="this.openEndDataModal('Departure')">Add Another Allocation
          </button>
          <span *appHasAnyPrivilege="'REPORT_GENERATE'">
          <button nz-button nzType="primary" *ngIf="bookingData.departureDetails.driverCategory === 'OUTSOURCE_DRIVER'"
                  (click)="showReportGenerate();generatePdf('dep')">Invoice - Outsourced Vehicles
          </button>
        </span>
        </div>
      </nz-card>

      <section id="departureDetails" class="mt-5">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Departure Details</h5>
              <div>

              </div>
            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Departure Flight Number</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureFlightNumber ?
                          (bookingData.tourDetails.departureTourDetails.departureFlightNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Departure Flight Time</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureFlightTime ?
                          (bookingData.tourDetails.departureTourDetails.departureFlightTime | date:'hh:mm a') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Flight Date</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureFlightDate ?
                          (bookingData.tourDetails.departureTourDetails.departureFlightDate | date:'yyyy-MM-dd') : '-'
                      }}
                    </p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Pick Up Time</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.departureTourDetails?.departurePickUpTime ?
                          (bookingData?.tourDetails?.departureTourDetails?.departurePickUpTime | date:'hh:mm a') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">PickUp Location</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.departureTourDetails?.departurePickUpLocation ?
                          (bookingData?.tourDetails?.departureTourDetails?.departurePickUpLocation) : '-'
                      }}</p>
                  </div>

                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Drop Off Location</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureDropOffLocation ?
                          (bookingData.tourDetails.departureTourDetails.departureDropOffLocation) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Drop Off City</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureDropOffCity ?
                          (bookingData.tourDetails.departureTourDetails.departureDropOffCity) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Distance to destination</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureDistanceToDestination ?
                          (bookingData.tourDetails.departureTourDetails.departureDistanceToDestination + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Date</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.departureTourDetails?.departureEndDate ?
                          (bookingData?.tourDetails?.departureTourDetails?.departureEndDate | date:'yyyy-MM-dd') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Time</p>
                    <p class="subject-data">{{
                        bookingData?.tourDetails?.departureTourDetails?.departureEndTime ?
                          (bookingData?.tourDetails?.departureTourDetails?.departureEndTime | date:'hh:mm a') : '-'
                      }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Number of Luggage</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureNoOfLuggages ?
                          (bookingData.tourDetails.departureTourDetails.departureNoOfLuggages) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Number of Passengers</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureNoOfPassengers ?
                          (bookingData.tourDetails.departureTourDetails.departureNoOfPassengers) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">N0. of Adults</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureNoOfAdults ?
                          (bookingData.tourDetails.departureTourDetails.departureNoOfAdults) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">No. of Children</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureNoOfChildren ?
                          (bookingData.tourDetails.departureTourDetails.departureNoOfChildren) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">No. of Infants</p>
                    <p class="subject-data">{{
                        bookingData.tourDetails.departureTourDetails.departureNoOfInfants ?
                          (bookingData.tourDetails.departureTourDetails.departureNoOfInfants) : '-'
                      }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>

      <section id="VehicleDetailsDeparture" class="mt-5"
               *ngIf="bookingData.departureDetails?.driverCategory === 'SR_DRIVER' ">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col xl:flex-row">
              <h5 class="text-primary">Vehicle Details</h5>
              <div class="flex flex-wrap lg:flex-nowrap lg:flex-row gap-2 items-center xl:justify-end">
                <button nz-button (click)="navigate('INSPECTION','dep')">Add Inspection Record</button>
                <button nz-button (click)="navigate('ACCIDENT','dep')">Add Accident Record</button>
                <button nz-button *ngIf="checkCanShowGenerateInventoryReportDep()"
                        (click)="showGenerateInventoryReportPopup(bookingData.departureDetails?.allocatedVehicle?._id)">
                  Generate Inventory Report
                </button>
              </div>
            </div>

            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">
              <div>
                <div class="sub-section" style="height: 100%">
                  <img *ngIf="bookingData.departureDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       height="nzAutosize" width="100%"
                       [src]="bookingData.departureDetails.allocatedVehicle.generalInformation.vehicleImg[0]"
                       alt="image">
                  <img *ngIf="!bookingData.departureDetails?.allocatedVehicle?.generalInformation?.vehicleImg[0]"
                       height="nzAutosize" width="100%" src="assets/img/image-placeholder.png" alt="image">
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Vehicle Brand</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.allocatedVehicle?.vehicleDetails?.vehicleBrand ?
                          (bookingData.departureDetails.allocatedVehicle.vehicleDetails.vehicleBrand) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Model</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.allocatedVehicle?.vehicleDetails?.vehicleModel ?
                          (bookingData.departureDetails.allocatedVehicle.vehicleDetails.vehicleModel) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Fuel Type</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.allocatedVehicle?.vehicleDetails?.fuelType
                          ? (bookingData.departureDetails.allocatedVehicle.vehicleDetails.fuelType) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Transmission</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.allocatedVehicle?.vehicleDetails?.transmission ?
                          (bookingData.departureDetails.allocatedVehicle.vehicleDetails.transmission) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Registration Number</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.allocatedVehicle?.vehicleDetails?.registrationNumber ?
                          (bookingData.departureDetails.allocatedVehicle.vehicleDetails.registrationNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">No. of Seats</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.allocatedVehicle?.vehicleDetails?.seatsNumber ?
                          (bookingData.departureDetails.allocatedVehicle.vehicleDetails.seatsNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Color</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.allocatedVehicle?.vehicleDetails?.color ?
                          (bookingData.departureDetails.allocatedVehicle.vehicleDetails.color) : '-'
                      }}</p>
                  </div>
                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Start Mileage</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails.startMileage ?
                          (bookingData.departureDetails.startMileage + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Start Fuel</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails.startFuel ?
                          (bookingData.departureDetails.startFuel + ' %') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Mileage</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails.endMileage ?
                          (bookingData.departureDetails.endMileage + ' KM') : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">End Fuel</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails.endFuel ?
                          (bookingData.departureDetails.endFuel + ' %') : '-'
                      }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>

      <section id="driverDetailsDeparture" class="mt-5">

        <nz-card>
          <div>
            <div class="flex justify-between gap-2 flex-col md:flex-row">
              <h5 class="text-primary">Driver Details</h5>

            </div>
            <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Driver Category</p>
                    <p *ngIf="bookingData.departureDetails?.allocateDriver?.driverSegment === 'SR_DRIVER'"
                       class="subject-data">SR
                      Driver</p>
                    <p *ngIf="bookingData.departureDetails?.allocateDriver?.driverSegment !== 'SR_DRIVER'"
                       class="subject-data">
                      Outsourced Driver</p>
                  </div>
                  <div class="item-row"
                       *ngIf="bookingData.departureDetails?.allocateDriver?.driverSegment !== 'SR_DRIVER'">
                    <p class="subject-name">Supplier</p>
                    <p style="cursor: pointer"
                       (click)="showSupplierModal(bookingData.departureDetails.allocateDriver.supplier)"
                       class="subject-data">{{
                        bookingData.departureDetails?.allocateDriver ?
                          bookingData.departureDetails?.allocateDriver?.supplier?.supplierDetails?.name : '-'
                      }}</p>
                  </div>
                  <div class="item-row"
                       *ngIf="bookingData.departureDetails?.allocateDriver?.driverSegment !== 'SR_DRIVER'">
                    <p class="subject-name">Outsourced Rate</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails?.outsourcedRate ?
                          (bookingData.departureDetails?.outsourcedRate + ' ' + bookingData.departureDetails?.outsourcedRateCurrencyDetails?.currencyCode) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Can Drive</p>
                    <div *ngFor="let item of bookingData.departureDetails.allocateDriver?.canDrive">
                      <p class="subject-data">{{ item.label ? (item.label + ',') : '-' }}</p>
                    </div>
                  </div>

                </div>
              </div>

              <div>
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Driver Name</p>
                    <p (click)="showDriverModal(bookingData.departureDetails.allocateDriver)" style="cursor: pointer"
                       class="subject-data">{{
                        bookingData.departureDetails.allocateDriver?.fullName ?
                          (bookingData.departureDetails.allocateDriver.fullName) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">NIC</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails.allocateDriver?.nicNo ?
                          (bookingData.departureDetails.allocateDriver.nicNo) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Mobile Number</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails.allocateDriver?.mobileNumber ?
                          (bookingData.departureDetails.allocateDriver.mobileNumber) : '-'
                      }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Email</p>
                    <p class="subject-data">{{
                        bookingData.departureDetails.allocateDriver?.email ?
                          (bookingData.departureDetails.allocateDriver.email) : '-'
                      }}</p>
                  </div>
                </div>
              </div>

              <div *ngIf="this.bookingData.departureDetails?.driverCategory === 'OUTSOURCE_DRIVER'">
                <div class="sub-section" style="height: 100%">
                  <div class="item-row">
                    <p class="subject-name">Vehicle Model</p>
                    <p class="subject-data">{{ departureVeh.model }}</p>
                  </div>
                  <div class="item-row">
                    <p class="subject-name">Vehicle Registration Number</p>
                    <p class="subject-data">{{ departureVeh.reg }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </nz-card>
      </section>

      <div *ngFor="let item of this.bookingData.departureDetails.allocationList.slice().reverse(); let i = index">
        <section id="VehicleAllocationDepDetails" class="mt-5"
                 *ngIf="item.vehicle ">

          <nz-card>
            <div>
              <div class="flex justify-between gap-2 flex-col lg:flex-row">
                <h5 class="text-primary">Vehicle Details (Previous - No: {{ i + 1 }} )</h5>
                <div class="flex flex-wrap md:flex-nowrap md:flex-row gap-2 items-center lg:justify-end ">
                  <!--                  <button nz-button (click)="navigate('INSPECTION')">Add Inspection Record</button>-->
                  <!--                  <button nz-button (click)="navigate('ACCIDENT')">Add Accident Record</button>-->
                </div>
              </div>
              <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

                <div>
                  <div class="sub-section" style="height: 100%">
                    <img *ngIf="item.vehicle?.generalInformation?.vehicleImg[0]" height="nzAutosize" width="100%"
                         [src]="item.vehicle?.generalInformation?.vehicleImg[0]" alt="image">
                    <img *ngIf="!item.vehicle?.generalInformation?.vehicleImg[0]" height="nzAutosize" width="100%"
                         src="assets/img/image-placeholder.png" alt="image">
                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Vehicle Brand</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.vehicleBrand ?
                            (item.vehicle?.vehicleDetails.vehicleBrand) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Model</p>
                      <p class="subject-data">{{
                          item.vehicle.vehicleDetails?.vehicleModel ?
                            (item.vehicle?.vehicleDetails.vehicleModel) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Fuel Type</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.fuelType ?
                            (item.vehicle?.vehicleDetails.fuelType) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Transmission</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.transmission ?
                            (item.vehicle?.vehicleDetails.transmission) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Registration Number</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.registrationNumber ?
                            (item.vehicle?.vehicleDetails.registrationNumber) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">No. of Seats</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.seatsNumber ?
                            (item.vehicle?.vehicleDetails.seatsNumber) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Color</p>
                      <p class="subject-data">{{
                          item.vehicle?.vehicleDetails?.color ?
                            (item.vehicle?.vehicleDetails.color) : '-'
                        }}</p>
                    </div>

                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Start Mileage</p>
                      <p class="subject-data">{{ item.startMileage ? (item.startMileage + ' KM') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Start Fuel</p>
                      <p class="subject-data">{{ item.startFuel ? (item.startFuel + ' %') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">End Mileage</p>
                      <p class="subject-data">{{ item.endMileage ? (item.endMileage + ' KM') : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">End Fuel</p>
                      <p class="subject-data">{{ item.endFuel ? (item.endFuel + ' %') : '-' }}</p>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </nz-card>
        </section>


        <section id="driverAllocationDepDetails" class="mt-5">

          <nz-card>
            <div>
              <div class="flex justify-between gap-2 flex-col md:flex-row">
                <h5 class="text-primary">Driver Details (Previous - No: {{ i + 1 }} )</h5>

              </div>
              <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-3 gap-8">

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Driver Category</p>

                      <p *ngIf="item.driver?.driverSegment === 'SR_DRIVER'" class="subject-data">SR Driver</p>
                      <p *ngIf="item.driver?.driverSegment !== 'SR_DRIVER'" class="subject-data">Outsourced Driver</p>
                    </div>
                    <div class="item-row" *ngIf="item.driver?.driverSegment === 'OUTSOURCE_DRIVER'">
                      <p class="subject-name">Supplier</p>
                      <p style="cursor: pointer" (click)="showSupplierModal(item.driver?.supplier)"
                         class="subject-data">{{ item.supplier ? item.supplier : '-' }}</p>
                    </div>
                    <div class="item-row" *ngIf="item.driver?.driverSegment === 'OUTSOURCE_DRIVER'">
                      <p class="subject-name">Outsourced Rate</p>
                      <p class="subject-data">{{ item.driver?.outsourcedRate ? item.driver?.outsourcedRate : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Can Drive</p>
                      <div *ngFor="let item of item.driver?.canDrive">
                        <p class="subject-data">{{ item.label ? (item.label + ',') : '-' }}</p>
                      </div>
                    </div>

                  </div>
                </div>

                <div>
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Driver Name</p>
                      <p (click)="showDriverModal(item.driver)" style="cursor: pointer" class="subject-data">{{
                          item.driver?.fullName ? (item.driver?.fullName) : '-'
                        }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">NIC</p>
                      <p class="subject-data">{{ item.driver?.nicNo ? (item.driver?.nicNo) : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Mobile Number</p>
                      <p class="subject-data">{{ item.driver?.mobileNumber ? (item.driver?.mobileNumber) : '-' }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Email</p>
                      <p class="subject-data">{{ item.driver?.email ? (item.driver?.email) : '-' }}</p>
                    </div>


                  </div>
                </div>

                <div *ngIf="!item.vehicle">
                  <div class="sub-section" style="height: 100%">
                    <div class="item-row">
                      <p class="subject-name">Vehicle Model</p>
                      <p class="subject-data">{{ item.driverVehModel }}</p>
                    </div>
                    <div class="item-row">
                      <p class="subject-name">Vehicle Registration Number</p>
                      <p class="subject-data">{{ item.driverVehReg }}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </nz-card>
        </section>
      </div>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>
    </div>


  </nz-tab>

  <nz-tab nzTitle="Booking Cost Details">
    <section>
      <nz-card [ngClass]="!loading ? 'block' : 'hidden'">
        <div class="mt-5 grid xl:grid-cols-3 gap-8 overflow-scroll">
          <div class="col-span-3 xl:col-span-2 min-w-[660px]">
            <div>
              <div class="grid grid-cols-6 gap-2 place-items-start pt-2">
                <div class="col-span-2">
                  <span class="cost-subject-data text-nowrap">Description</span>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="cost-subject-data text-nowrap justify-end">Currency Type</p>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="cost-subject-data text-nowrap">Amount</p>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="cost-subject-data text-nowrap">LKR Rate</p>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="cost-subject-data text-nowrap text-end">LKR Amount</p>
                </div>
              </div>
              <nz-divider class="custom-margin"></nz-divider>
            </div>
            <div class="mt-5">
              <h6 class="mb-4">Cost Types and Amount</h6>
              <div class="grid grid-cols-6 gap-2">
                <div class="col-span-2">
                  <span class="subject-name">Transfer Cost</span>
                </div>

                <div class="flex flex-row w-full justify-end">
                  <p class="cost-subject-data text-start">
                    {{ bookingData?.bookingCost?.transferCurrencyDetails?.currencyCode }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p
                    class="cost-subject-data text-start">{{ bookingData?.bookingCost?.transferCost | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="cost-subject-data text-start">
                    {{ bookingData?.bookingCost?.transferCurrencyDetails?.lkrRate | number:'1.2-2' }}</p>
                </div>
                <div class="flex flex-row w-full justify-end">
                  <p class="cost-subject-data text-end">{{
                      bookingData?.bookingCost?.transferCost *
                      bookingData?.bookingCost?.transferCurrencyDetails?.lkrRate | number:'1.2-2'
                    }}</p>
                </div>

              </div>
              <div class="mt-3">
                <div class="flex justify-between">
                  <p class="subject-name" style="color: #282828 !important;">Extra Charges</p>
                  <p class="cost-subject-data"></p>
                </div>
                <nz-divider class="custom-margin"></nz-divider>
                <div class="">
                  <div *ngFor="let charge of bookingData?.bookingCost?.extraCharges"
                       class="grid grid-cols-6 gap-2">
                    <div class="col-span-2">
                      <span class="subject-name">{{ charge?.chargeType }}</span>
                    </div>

                    <div class="flex flex-row w-full justify-end">
                      <p
                        class="cost-subject-data text-start">{{
                          charge?.currencyDetails ? charge?.currencyDetails?.currencyCode
                            : 'LKR'
                        }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="cost-subject-data text-start">{{ charge?.amount | number:'1.2-2' }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="cost-subject-data text-start">{{
                          charge?.currencyDetails ? (charge?.currencyDetails?.lkrRate | number:'1.2-2') :
                            '-'
                        }}</p>
                    </div>
                    <div class="flex flex-row w-full justify-end">
                      <p class="cost-subject-data text-end" >{{
                          charge?.currencyDetails ? ((charge?.amount *
                            charge?.currencyDetails?.lkrRate) | number:'1.2-2') : (charge?.amount | number:'1.2-2')
                        }}</p>
                    </div>


                  </div>
                </div>
                <div class="flex justify-between">
                  <p class="subject-name custom_font-bold">Total Extra Charges</p>
                  <p class="subject-data_1 text-start font-bold">{{ getTotalExtraCharges() | number:'1.2-2' }}</p>
                </div>
              </div>
              <div class="flex justify-between my-3">
                <p class="subject-name custom_font-bold">Total Cost</p>
                <p class="subject-data_1 font-bold">{{
                    ((bookingData?.bookingCost?.transferCurrencyDetails?.lkrRate *
                      bookingData?.bookingCost?.transferCost) + getTotalExtraCharges()) | number:'1.2-2'
                  }}</p>
              </div>
            </div>
          </div>
        </div>
      </nz-card>

      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-single-view-skeleton-template [typeName]="'cost-detail'"></app-single-view-skeleton-template>
      </div>
    </section>


  </nz-tab>

  <nz-tab nzTitle="Other Details">

    <section>
      <nz-card>
        <div [ngClass]="!loading ? 'block' : 'hidden'" class="mt-5 grid xl:grid-cols-2 gap-2">
          <div>
            <div class="flex mb-5">
              <p class="font-semibold mr-5">Special Instruction</p>
            </div>
            <textarea class="mt-2" rows="8" nz-input id="disabledTextarea" [(ngModel)]="instructions"
                      disabled></textarea>
          </div>
          <div>
            <!--              <nz-divider></nz-divider>-->
            <div class="flex  mt-0 justify-between items-center ">
              <p class="font-semibold mr-5">User Comments</p>
              <button nz-button nzType="primary" (click)="visibleAddEditComment('add')">Add Comment
              </button>
            </div>
            <div>
              <div class="grid  grid-cols-12 ">
                <p class="col-span-2 text-sm mx-2 font-bold">Date</p>
                <p class="col-span-5 text-sm mx-2 font-bold">Comment</p>
                <!--                <p class="text-sm mx-2">{{comment?.remark}}</p>-->
                <!--                <p>{{remark?.createdBy?.firstname + " " + remark?.createdBy?.lastname}}</p>-->
                <p class="col-span-3 text-sm mx-2 font-bold">User</p>
                <p class="col-span-2 text-sm mx-2 font-bold">Actions</p>
              </div>
              <div *ngFor="let comment of userComments; index as i">
                <div class="grid  grid-cols-12 mt-2 content-center ">
                  <p class="col-span-2 text-sm mx-2">{{ comment?.createdAt | date: 'dd-MM-y' }}</p>
                  <p class="col-span-5 text-sm mx-2">{{ comment?.comment }}</p>
                  <p
                    class="col-span-3 text-sm mx-2">{{ comment?.createdBy.firstname + ' ' + comment?.createdBy.lastname }}</p>
                  <!--                <p class="text-sm mx-2">{{comment?.remark}}</p>-->
                  <!--                <p>{{remark?.createdBy?.firstname + " " + remark?.createdBy?.lastname}}</p>-->
                  <div class="flex justify-center gap-4">
                    <button class="outline-button more-dropdown" nz-button nz-dropdown [nzDropdownMenu]="commentMenu"
                            nzPlacement="bottomCenter">
                      <span nz-icon nzType="more" nzTheme="outline"></span>
                    </button>
                    <nz-dropdown-menu #commentMenu="nzDropdownMenu">
                      <ul nz-menu>
                        <li
                          nz-menu-item nz-popconfirm nz-button
                          (click)="visibleAddEditComment('edit', comment, i)">Edit
                        </li>
                        <li nz-menu-item nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this comment?"
                            [nzOkText]="'Yes'"
                            [nzCancelText]="'No'" (nzOnCancel)="cancelDeleteComment()"
                            (nzOnConfirm)="deleteComment(i)">Delete
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                </div>
                <nz-divider></nz-divider>
              </div>
              <div class="grid grid-cols-5 mt-2 content-center">
                <p class="text-sm mx-2" *ngIf="!userComments || userComments.length ===0 ">
                  <!-- Display content when userComments is not null and has items -->
                </p>
                <p class="text-sm mx-2" *ngIf="!userComments || userComments.length === 0">
                  <!-- Display content when userComments is not null and has items -->
                </p>
                <p class="mx-2 mt-4" *ngIf="!userComments || userComments.length === 0">
                  No Data
                </p>
                <p class="text-sm mx-2" *ngIf="!userComments || userComments.length === 0">
                  <!-- Display content when userComments is not null and has items -->
                </p>
                <p class="text-sm mx-2" *ngIf="!userComments || userComments.length === 0">
                  <!-- Display content when userComments is not null and has items -->
                </p>
              </div>
            </div>
          </div>

          <div *appHasAnyPrivilege="'RENT_BOOKING_REMARKS_VIEW'">
            <nz-divider></nz-divider>
            <div class="flex mb-5">
              <p class="font-semibold mr-5">Remarks</p>
            </div>
            <div>
              <div class="grid grid-cols-3">
                <p class="text-sm mx-2 font-bold">Date</p>
                <p class="text-sm mx-2 font-bold">Action</p>
                <p class="text-sm mx-2 font-bold">Remark</p>
                <!--                <p>{{remark?.createdBy?.firstname + " " + remark?.createdBy?.lastname}}</p>-->
              </div>
            </div>
            <div *ngFor="let remark of bookingData?.remarks">
              <div class="grid grid-cols-3 mt-2 content-center">
                <p class="text-sm mx-2">{{ remark?.createdAt | date: 'dd-MM-y' }}</p>
                <p class="text-sm mx-2">{{ remark?.action }}</p>
                <p class="text-sm mx-2">{{ remark?.remark }}</p>
                <!--                <p>{{remark?.createdBy?.firstname + " " + remark?.createdBy?.lastname}}</p>-->
              </div>
              <nz-divider></nz-divider>
            </div>
            <div class="grid grid-cols-3 mt-2 content-center">
              <p class="text-sm mx-2" *ngIf="!bookingData?.remarks === null || bookingData?.remarks.length < 1">
              </p>
              <p class="text-sm mx-2 mt-4" *ngIf="!bookingData?.remarks === null || bookingData?.remarks.length < 1">No
                Data</p>
              <p class="text-sm mx-2" *ngIf="!bookingData?.remarks === null || bookingData?.remarks.length < 1">
              </p>
            </div>
          </div>
        </div>
        <div [ngClass]="loading ? 'block' : 'hidden'">
          <app-single-view-skeleton-template [typeName]="'note-view'"></app-single-view-skeleton-template>
        </div>
      </nz-card>
    </section>

  </nz-tab>

  <nz-tab nzTitle="Reports" *appHasAnyPrivilege="'REPORT_GENERATE'">
    <section>
      <nz-card [ngClass]="!loading ? 'block' : 'hidden'">
        <div class="grid lg:grid-cols-2 gap-5">
          <div>
            <h5>Generate Reports</h5>
            <div class="mt-5">
              <hr>
              <div
                class="flex flex-col  min-[400px]:flex-row  min-[400px]:justify-between min-[400px]:items-center w-full gap-4 ">
                <div class="flex items-center gap-2">
                  <span nz-icon nzType="file" nzTheme="outline" class="icon-color"></span>
                  <p>Paging Board</p>
                </div>
                <div class="sm:mr-5 ">
                  <button nz-button nzType="primary" class="max-[400px]:w-full "
                          (click)="openBookingCatSelectPagingBoardModal()">Generate
                  </button>
                </div>
              </div>
              <hr>
            </div>
          </div>
        </div>

      </nz-card>
    </section>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-single-view-skeleton-template [typeName]="'report'"></app-single-view-skeleton-template>
    </div>

  </nz-tab>
</nz-tabset>


<nz-modal [(nzVisible)]="isVisibleAddEditComment" [nzTitle]="commentModalTitle" [nzContent]="commentModalContent"
          [nzFooter]="commentModalFooter" (nzOnCancel)="handleCancelAddEditComment()">
  <ng-template #commentModalTitle>{{ selectedComment ? 'Edit Comment' : 'Add Comment' }}</ng-template>

  <ng-template #commentModalContent>
    <div class="flex flex-col gap-4">
      <p class="font-bold">Comment</p>
      <textarea nz-input placeholder="Enter Comment" [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                [(ngModel)]="comment"></textarea>
    </div>
  </ng-template>

  <ng-template #commentModalFooter>
    <button nz-button nzType="default" (click)="handleCancelAddEditComment()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="(comment === null)" nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information ?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'"
            (nzOnCancel)="handleCancelAddEditComment()" (nzOnConfirm)="handleSubmitUserComment()"
            [nzLoading]="isLoadingCommentModal">Save
    </button>
  </ng-template>
</nz-modal>

<app-single-view-customer-popup [isVisible]="visibleCustomerModal" (viewCustomerOnchange)="CustomerModal($event)"
                                [customerData]="bookingData?.tourDetails?.customer"></app-single-view-customer-popup>

<app-single-view-driver-popup [isVisible]="visibleDriverModal" (viewDriverOnchange)="DriverModal($event)"
                              [driverData]="this.selectedDriver"></app-single-view-driver-popup>
<app-single-view-supplier-popup *ngIf="visibleSupplierModal" [isVisible]="visibleSupplierModal"
                                (viewSupplierOnchange)="SupplierModal($event)"
                                [supplierId]="this.selectedSupplier?._id"></app-single-view-supplier-popup>


<nz-modal [(nzVisible)]="isVisibleAddAllocation" [nzTitle]="modal3Title" [nzContent]="modal3Content"
          [nzFooter]="modal3Footer" (nzOnCancel)="handleCancelAllocation()">
  <ng-template #modal3Title>Add Another Allocation</ng-template>

  <ng-template #modal3Content>

    <form nz-form [formGroup]="allocationForm" [nzLayout]="'vertical'">
      <div class=" grid xl:grid-cols-2 gap-2">


        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="vehicleCategory" nzRequired>Vehicle Category</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="vehicleCategory" (ngModelChange)="getVehicles($event)"
                       nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let category of vehicleCat" [nzValue]="category._id"
                         [nzLabel]="category.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="allocatedVehicle" nzRequired>Allocated Vehicle</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="allocatedVehicle" (ngModelChange)="getVehicleFuelAndMileage($event)" nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let vehicle of this.availableVehicles" [nzValue]="vehicle._id"
                         [nzLabel]="vehicle.vehicleName"></nz-option>
            </nz-select>
          </nz-form-control>
          <p class="my-2 text-primary text-sm" *ngIf="fleetsFetching">Loading...</p>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="startMileage" nzRequired>Start Mileage ( KM )</nz-form-label>
          <nz-form-control>
            <nz-input-group nzAddOnAfter="Km">
              <input nz-input type="number" [min]="0" [step]="1" formControlName="startMileage" placeholder="Enter Number"/>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start">
          <nz-form-label nzFor="startFuel" nzRequired>Start Fuel ( % )</nz-form-label>
          <nz-form-control>
            <nz-input-group nzAddOnAfter="%">
              <input nz-input type="number" [min]="0" [max]="100" [step]="1" formControlName="startFuel" placeholder="Enter Number"/>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <span nz-checkbox formControlName="driverAllocationCheck" class="mb-4">Driver Allocation</span>

        <span></span>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="driverCategory" nzRequired>Driver Category</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="driverCategory" (ngModelChange)="getDriverOptions($event)"
                       nzPlaceHolder="Select Preference">
              <nz-option nzValue="SR_DRIVER" nzLabel="SR Drivers"></nz-option>
              <nz-option nzValue="OUTSOURCE_DRIVER" nzLabel="Outsourced Drivers"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <span></span>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="allocatedDriver" nzRequired>Allocated Driver</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="allocateDriver"
                       (ngModelChange)="getSupplierVehicles($event);getDriver($event)"
                       nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let op of availableDriver" nzValue="{{op._id}}" nzLabel="{{op.fullName}}"></nz-option>
            </nz-select>
          </nz-form-control>
          <p class="my-2 text-primary text-sm" *ngIf="driversFetching">Loading...</p>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value !== null">
          <nz-form-control>
            <button (click)="showAddDriverPopup()" (keydown.enter)="$event.preventDefault()"
                    class="outline-button  custom-btn_add" nz-button
                    nzType="default" style="margin-top: 2.15rem; width: 150px">Add New
              Driver
            </button>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER' && allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="allocatedDriverVehicle" nzRequired>Allocated Vehicle</nz-form-label>
          <nz-form-control>
            <nz-select class="w-full" formControlName="allocateVehicle" nzPlaceHolder="Select Preference">
              <nz-option *ngFor="let op of supplierVehicleOptions" nzValue="{{op?._id}}"
                         nzLabel="{{op?.registerNumber}} | {{op?.vehicleModel}}"></nz-option>
            </nz-select>
          </nz-form-control>
          <p class="my-2 text-primary text-sm" *ngIf="supplierVehiclesFetching">Loading...</p>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER'">
          <nz-form-control>
            <button (click)="showAddVehiclePopup()"
                    [disabled]="this.allocationForm.get('allocateDriver').value === null"
                    (keydown.enter)="$event.preventDefault()" class="outline-button"
                    style="margin-top: 2.15rem; width: 150px" nz-button
                    nzType="default">Add New
              Vehicle
            </button>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="grid grid-flow-row content-start"
                      *ngIf="allocationForm.get('driverCategory').value === 'OUTSOURCE_DRIVER' && allocationForm.get('driverAllocationCheck').value">
          <nz-form-label nzFor="outsourcedRate" nzRequired>Outsourced Rate</nz-form-label>
          <nz-form-control [nzErrorTip]="Outsourced">
            <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate">
              <nz-input-number formControlName="outsourcedRate" [nzPlaceHolder]="'Enter rate'" [nzStep]="1"
                               [nzMin]="0"></nz-input-number>
            </nz-input-number-group>
            <ng-template #addOnAfterTemplate>
              <div style="display: flex; align-items: center;">
                <span></span>
                <nz-select formControlName="transferCurrency" style="width: 80px;">
                  <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                             [nzLabel]="op.currencyCode"></nz-option>
                </nz-select>
              </div>
            </ng-template>
            <ng-template #Outsourced>
            </ng-template>
          </nz-form-control>
        </nz-form-item>


      </div>
    </form>
  </ng-template>

  <ng-template #modal3Footer>
    <button nz-button nzType="default" (click)="handleCancelAllocation()">Cancel</button>
    <button nz-button nzType="primary" (click)="saveAllocation()" [disabled]="this.allocationForm.invalid">Save</button>
  </ng-template>
</nz-modal>


<nz-modal [(nzVisible)]="isVisibleEndData" [nzTitle]="modal2Title" [nzContent]="modal2Content" [nzFooter]="modal2Footer"
          (nzOnCancel)="handleCancelEndData()">
  <ng-template #modal2Title></ng-template>

  <ng-template #modal2Content>

    <div class="flex flex-col gap-4">
      <p class="font-bold">End Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="endMileage" placeholder="Enter Mileage"/>
      </nz-input-group>
      <p class="font-bold">End Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="endFuel" placeholder="Enter Fuel Level"/>
      </nz-input-group>
    </div>

  </ng-template>

  <ng-template #modal2Footer>
    <button nz-button nzType="default" (click)="handleCancelEndData()">Cancel</button>
    <button nz-button nzType="primary" (click)="saveEndData()">Save</button>
  </ng-template>
</nz-modal>

<app-payment-popup [isVisible]="visiblePaymentPopup"
                   (addPaymentOnChange)="onGetAddPaymentChange($event)"></app-payment-popup>


<nz-modal [(nzVisible)]="isVisibleFuelAndMileageUpdate" [nzTitle]="modalTitle5" [nzContent]="modalContent5"
          [nzFooter]="modalFooter5" (nzOnCancel)="handleCancelUpdateFuelAndMileage()">
  <ng-template #modalTitle5>{{
      changingStatus === 'CANCELLED' ? 'Reason for Cancellation' : 'Current Fuel and Mileage
        Update'
    }}
  </ng-template>

  <ng-template #modalContent5>
    <div *ngIf="changingStatus === 'ON_TRANSFER' || changingStatus === 'COMPLETED'" class="flex flex-col gap-4">
      <p class="font-bold">{{ changingStatus === 'ON_TRANSFER' ? 'Start' : 'End' }} Mileage :</p>
      <nz-input-group nzAddOnAfter="Km">
        <input nz-input type="number" [min]="0" [step]="1" [(ngModel)]="mileage" placeholder="Enter Mileage"/>
      </nz-input-group>

      <p class="font-bold">{{ changingStatus === 'ON_TRANSFER' ? 'Start' : 'End' }} Fuel Level :</p>
      <nz-input-group nzAddOnAfter="%">
        <input nz-input type="number" [min]="0" [max]="100" [step]="1" [(ngModel)]="fuelLevel" placeholder="Enter Fuel Level"/>
      </nz-input-group>
    </div>

    <div *ngIf="changingStatus === 'CANCELLED'" class="flex flex-col">
      <p class="font-bold">Reason to Cancel :</p>
      <nz-select class="w-full" [(ngModel)]="cancelReason" nzPlaceHolder="Select Preference" nzShowSearch nzAllowClear
                 [nzDropdownRender]="renderTemplate">
        <nz-option *ngFor="let item of cancelReasonOptions" [nzLabel]="item" [nzValue]="item"></nz-option>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-divider></nz-divider>
        <div class="flex flex-col justify-center mx-3">
          <input type="text" nz-input #inputElement/>
          <a class="text-center m-1" (click)="addItem(inputElement)">
            <span nz-icon nzType="plus"></span>
            Add item
          </a>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-template #modalFooter5>
    <button nz-button nzType="default" (click)="handleCancelUpdateFuelAndMileage()">Cancel</button>
    <button *ngIf="!(changingStatus === 'CANCELLED')" nz-button nzType="primary"
            [disabled]="(fuelLevel === 0 || undefined) || (mileage === 0 || undefined)" nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information and change the status?" [nzOkText]="'Yes'"
            [nzCancelText]="'No'" (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkUpdateFuelAndMileage()" [nzLoading]="isLoading">Save
    </button>
    <button *ngIf="changingStatus === 'CANCELLED'" nz-button nzType="primary" [disabled]="(cancelReason === null)"
            nz-popconfirm nzPopconfirmTitle="Are you sure you want to save this information and change the status?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="handleCancelUpdateFuelAndMileage()"
            (nzOnConfirm)="handleOkCancelledStatus()" [nzLoading]="isLoading">Save
    </button>
  </ng-template>
</nz-modal>

<nz-modal [(nzVisible)]="isShowReport" [nzTitle]="modalTitle12" [nzContent]="modalContent12" [nzFooter]="modalFooter12"
          (nzOnCancel)="handleCancel()" nzClosable="false">
  <ng-template #modalTitle12>
    <div class="flex justify-between items-center my-4">
      <h4>Invoice for Outsource Vehicle</h4>
      <button nz-button nzType="primary" *appHasAnyPrivilege="''" [disabled]="!this.pdfLoader"
              (click)="viewPdf()">Preview
      </button>
    </div>
  </ng-template>

  <ng-template #modalContent12>
    <div class="my-4">
      <p style="font-weight: normal; color:#F06A21" *ngIf="!this.pdfLoader">Report Generating ....</p>
      <p style="font-weight: normal" *ngIf="this.pdfLoader">Report Generated Successfully!</p>
    </div>
  </ng-template>

  <ng-template #modalFooter12>
    <div class="flex justify-between items-center my-4">
      <button nz-button nzType="default" style="color: white; background: #9A9A9A;border-color: #9A9A9A"
              (click)="handleCancel()">
        Cancel
      </button>
      <div class="flex gap-2">
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="downloadPdf()">
          Download
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="emailPdf()">
          Send
        </button>
        <button nz-button nzType="default" [disabled]="!this.pdfLoader" class="outline-button" (click)="printReport()">
          Print
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>
<nz-modal [(nzVisible)]="bookingCatSelectPagingBoardModal" [nzContent]="modalContentBookingCatSelect"
          [nzFooter]="modalFooterBookingCatSelect" (nzOnCancel)="cancelBookingCatSelectPagingBoardModal()">
  <ng-template #modalContentBookingCatSelect>
    <div class="my-4">
      <p style="font-weight: normal">Which one is base to generate paging board ?</p>
    </div>
  </ng-template>

  <ng-template #modalFooterBookingCatSelect>
    <div class="flex justify-end items-center my-4">
      <button nz-button nzType="primary" (click)="openGeneratePagingBoardModal('Arrival')">Arrival</button>
      <button nz-button nzType="primary" (click)="openGeneratePagingBoardModal('Departure')">Departure</button>
    </div>
  </ng-template>
</nz-modal>


<app-generate-inventory-report-popup *ngIf="isVisibleGenerateInventoryReport"
                                     (handleGenerateInventoryReportOnChange)="onGetGenerateInventoryReportChange($event)"
                                     [isVisibleGenerateInventoryReport]="isVisibleGenerateInventoryReport"
                                     [inventoryId]="relevantInventoryId"
                                     [bookingData]="inventoryBookingData"></app-generate-inventory-report-popup>

<app-generate-paging-board-popup *ngIf="isVisibleGeneratePagingBoardModal"
                                 (handleGeneratePagingBoardModalOnChange)="onGetGeneratePagingBoardChange($event)"
                                 [isVisibleGeneratePagingBoardModal]="isVisibleGeneratePagingBoardModal"
                                 [pagingBoardData]="defaultPagingBoardData"></app-generate-paging-board-popup>

<app-add-driver-popup [isVisible]="visibleAddDriverPopup"
                      (addEditDriverOnChange)="onGetAddDriverChange($event)"></app-add-driver-popup>
<app-vehicle-details-form [isVisible]="visibleAddVehiclePopup" [supplier]="selectedSupplierId"
                          (addVehicleOnChange)="onGetAddVehicleChange($event)"></app-vehicle-details-form>
